import onDomContentLoaded from '../../utilities/onDomContentLoaded';
import ErrorBoundary from '../../components/ErrorBoundary';
import '../../../scss/pages/privacy-policy/main.scss';
import { YourDataContainer } from './YourDataContainer';
import { createRoot } from 'react-dom/client';

function startup() {
    const modalInitContainer: HTMLElement | null = document.getElementById('your-data--modal-init');

    if (modalInitContainer) {
        const root = createRoot(modalInitContainer);
        root.render(
            <ErrorBoundary>
                <YourDataContainer />
            </ErrorBoundary>,
        );
    }
}

onDomContentLoaded(() => {
    startup();
});
